<div class="card-body p-0" *ngIf="listaAgrupadaFolhaTeste?.length > 0; else content">

    <div id="accordion-folha-teste">
        <!-- Nível 1: Unidade Gestora -->
        <div *ngFor="let ug of listaAgrupadaFolhaTeste; let i = index;">
            <div class="card p-0">
                <div class="card-header" id="heading-ug-{{i}}">
                    <h5 class="mb-0">
                        <div class="d-flex justify-content-between align-items-center">
                            <button class="btn btn-link limit-text" data-toggle="collapse"
                                attr.data-target="#collapse-ug-{{i}}" aria-expanded="false"
                                attr.aria-controls="collapse-ug-{{i}}">
                                FOLHA TESTE - <strong> {{ ug.unidadeGestoraNome | uppercase }} </strong>
                            </button>
                        </div>
                    </h5>
                </div>

                <div id="collapse-ug-{{i}}" class="collapse" attr.aria-labelledby="heading-ug-{{i}}"
                    attr.data-parent="#accordion-folha-teste">

                    <!-- Container para as amostras dessa UG -->
                    <div id="accordion-amostra-ug-container-{{i}}">
                        <!-- Nível 2: Amostras -->
                        <div *ngFor="let amostra of ug.amostras; let j = index" class="accordion-subitem">
                            <div class="card">

                                <div class="card-header d-flex justify-content-between align-items-end"
                                    id="heading-amostra-ug-{{i}}-{{j}}">
                                    <h5 class="mb-0">
                                        <button class="btn btn-link text-start" data-toggle="collapse"
                                            attr.data-target="#collapse-amostra-ug-{{i}}-{{j}}" aria-expanded="false"
                                            attr.aria-controls="collapse-amostra-ug-{{i}}-{{j}}">
                                            AMOSTRA - <strong> {{ amostra.amostraNome | uppercase }} </strong>
                                        </button>
                                    </h5>

                                    <button type="button" class="btn btn-success btn-sm ml-auto"
                                        *ngIf="!visualizar && statusProgramaTrabalho == 1 && !bloqueadoPorMatriz"
                                        (click)="addFolhaTeste(ug.unidadeGestoraId, amostra.amostraId)">
                                        <i class="fas fa-plus"></i> Adicionar Folha Teste
                                    </button>

                                </div>

                                <div id="collapse-amostra-ug-{{i}}-{{j}}" class="collapse"
                                    attr.aria-labelledby="heading-amostra-ug-{{i}}-{{j}}"
                                    attr.data-parent="#accordion-amostra-ug-container-{{i}}">
                                    <div class="card-body p-0 mat-elevation-z1">
                                        <app-osa-execucao-aba-folha-teste-lista [visualizar]="visualizar"
                                            [osaExecucaoId]="id" [amostraId]="amostra.amostraId"
                                            [unidadeGestoraId]="ug.unidadeGestoraId" [numeroOsa]="numeroOsa"
                                            [listaDados]="amostra.folhas"
                                            [statusProgramaTrabalho]="statusProgramaTrabalho"
                                            [bloqueadoPorMatriz]="bloqueadoPorMatriz">
                                        </app-osa-execucao-aba-folha-teste-lista>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div id="accordion-programa-trabalho">
        <!-- Nível 1: Unidade Gestora -->
        <div *ngFor="let programaTrabalho of listaProgramaTrabalho; let i = index;">
            <div class="card p-0">
                <div class="card-header" id="heading-programa-trabalho-ug-{{i}}">
                    <h5 class="mb-0">
                        <div class="d-flex justify-content-between align-items-center">
                            <button class="btn btn-link limit-text" data-toggle="collapse"
                                attr.data-target="#collapse-programa-trabalho-ug-{{i}}" aria-expanded="false"
                                attr.aria-controls="collapse-programa-trabalho-ug-{{i}}">
                                PROGRAMA DE TRABALHO - <strong> {{ programaTrabalho.unidadeGestora?.nome | uppercase }}
                                </strong>
                            </button>
                        </div>
                    </h5>
                </div>
                <div id="collapse-programa-trabalho-ug-{{i}}" class="collapse"
                    attr.aria-labelledby="heading-programa-trabalho-ug-{{i}}"
                    attr.data-parent="#accordion-programa-trabalho">
                    <!-- Container para os planos de trabalho dessa UG -->
                    <div id="accordion-programa-trabalho-ug-container-{{i}}">
                        <div class="card-body p-0 mat-elevation-z1">
                            <app-osa-execucao-aba-folha-teste-programa-trabalho-lista [visualizar]="visualizar"
                                [osaExecucaoId]="id" [unidadeGestoraId]="programaTrabalho.unidadeGestoraId"
                                [planejamentoId]="planejamentoId" [numeroOsa]="numeroOsa"
                                [listaDados]="listaProgramaTrabalho"
                                (atualizarProgramaTrabalho)="atualizarProgramaTrabalho()">
                            </app-osa-execucao-aba-folha-teste-programa-trabalho-lista>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="card-body p-0">
    <ng-template #content>
        <h5 class="table-no-data">
            Nenhuma Folha Teste Gerada para essa Execução.
        </h5>
    </ng-template>
</div>